<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="create_warehouse_transfer" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_create_warehouse_transfer_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!filtersets.newGroup1.hidden && !filtersets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup1.collapsible }">
                    <div *ngIf="!filtersets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup1.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-warehouses" *ngIf="!filters.warehouses.hidden && !filters.warehouses.removed" 
                                  class="field-container standard {{filters.warehouses.invalid ? 'invalid' : ''}} {{filters.warehouses.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.warehouses.styles.style"
                                  [ngClass]="filters.warehouses.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouses.label + (filters.warehouses.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouses.label}}<span *ngIf="filters.warehouses.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-warehouses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.warehouses.control.type"
                                  formControlName="warehouses"
                                  (displayTextChange)="filters.warehouses.control.displayText=$event"
                                  [placeholder]="filters.warehouses.control.placeholder"
                                  [styles]="filters.warehouses.control.styles"
                                  [tooltip]="filters.warehouses.control.tooltip"
                              >
                              </Locations-warehouses_dd_multi>
                              <ng-container *ngIf="filters.warehouses.invalid">
                                <ng-container *ngFor="let error of filters.warehouses.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-warehouse_transfer_statuses" *ngIf="!filters.warehouse_transfer_statuses.hidden && !filters.warehouse_transfer_statuses.removed" 
                                  class="field-container standard {{filters.warehouse_transfer_statuses.invalid ? 'invalid' : ''}} {{filters.warehouse_transfer_statuses.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.warehouse_transfer_statuses.styles.style"
                                  [ngClass]="filters.warehouse_transfer_statuses.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouse_transfer_statuses.label + (filters.warehouse_transfer_statuses.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouse_transfer_statuses.label}}<span *ngIf="filters.warehouse_transfer_statuses.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <WarehouseTransfers-warehousetransfer_statuses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.warehouse_transfer_statuses.control.type"
                                  formControlName="warehouse_transfer_statuses"
                                  (displayTextChange)="filters.warehouse_transfer_statuses.control.displayText=$event"
                                  [placeholder]="filters.warehouse_transfer_statuses.control.placeholder"
                                  [styles]="filters.warehouse_transfer_statuses.control.styles"
                                  [tooltip]="filters.warehouse_transfer_statuses.control.tooltip"
                              >
                              </WarehouseTransfers-warehousetransfer_statuses_dd_multi>
                              <ng-container *ngIf="filters.warehouse_transfer_statuses.invalid">
                                <ng-container *ngFor="let error of filters.warehouse_transfer_statuses.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
              
                          <div class="fieldset-details" *ngIf="!filtersets.newGroup1.expanded">
              
              
                          </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.warehouse_transfers.hasTabToShow" class="tab" data-cy="tab-warehouse_transfers">
              <h2 [className]="tabs.warehouse_transfers.active? 'active': ''" (click)="tabs.warehouse_transfers.activate()">{{tabs.warehouse_transfers.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-warehouse_transfers_grid *ngIf="tabs.warehouse_transfers.active"
              #$tabs_warehouse_transfers
              [warehouseIds]="$tabs_warehouse_transfers_warehouse_transfers_grid_inParams_warehouseIds"
              [statusIds]="$tabs_warehouse_transfers_warehouse_transfers_grid_inParams_statusIds"
              ($refreshEvent)="refresh(false, false, '$tabs_warehouse_transfers')">
              </FootprintManager-warehouse_transfers_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>